import { useQuery } from 'react-query'

import { GeometryAnomalies } from '../../../types/drugRegistry'
import { get } from '../../../utils/api'

/**
 * Registry-wide counts: the backend ignores the table's filters, so the key
 * doesn't depend on them and narrowing the table doesn't refetch the panel.
 */
export const useGeometryAnomalies = () =>
  useQuery<GeometryAnomalies>(
    ['drug-registry', 'geometry-anomalies'],
    () => get<GeometryAnomalies>('/drug-registry/geometry-anomalies/'),
    { retry: false }
  )
